import { ProgressBar as RBProgressBar, ProgressBarProps } from 'react-bootstrap';

import './ProgressBar.scss';

export default function ProgressBar(props: ProgressBarProps) {
  return <RBProgressBar {...props} />;
}
